import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'valueChange',
})
export class ValueChangePipe implements PipeTransform {
  transform(value: number | string, attribute: string): string {
    if (value) {
      const isPositive = Number(value) > 0
      const statusMap = {
        altText: isPositive ? 'increased' : 'decreased',
        name: isPositive ? 'positive-change' : 'negative-change',
      }
      return statusMap[attribute]
    }

    return ''
  }
}
